import Vue from 'vue';
import Vuex from 'vuex';

import redbook from '@/store/modules/redbook.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    redbook,
  },
});
